import { PrismicRichText } from "@prismicio/react";
import { isFilled } from "@prismicio/client";

/**
 * @typedef {import("@prismicio/client").Content.TexteSlice} TexteSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<TexteSlice>} TexteProps
 * @type {import("react").FC<TexteProps>}
 */
const Texte = ({ slice }) => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="bg-beige text-dark-pink px-5 md:px-20 pt-20 md:pt-50 pb-10 md:pb-25 min-h-screen"
    >
      {isFilled.richText(slice.primary.text) && (
        <PrismicRichText
          field={slice.primary.text}
          components={{
            heading1: ({ children }) => <h1 className="h1 mb-4">{children}</h1>,
            heading2: ({ children }) => <h2 className="h2 mb-3">{children}</h2>,
            heading3: ({ children }) => <h3 className="h3 mb-3">{children}</h3>,
            heading4: ({ children }) => <h4 className="h4 mb-2">{children}</h4>,
            heading5: ({ children }) => <h5 className="font-body text-xl md:text-2xl font-bold mb-2">{children}</h5>,
            heading6: ({ children }) => <h6 className="font-body text-lg md:text-xl font-bold mb-2">{children}</h6>,
            paragraph: ({ children }) => <p className="p mb-4 last:mb-0">{children}</p>,
            strong: ({ children }) => <strong className="font-bold">{children}</strong>,
            em: ({ children }) => <em className="italic">{children}</em>,
            hyperlink: ({ children, node }) => (
              <a 
                href={node.data.url} 
                target={node.data.target} 
                className="underline hover:opacity-70 transition-opacity"
              >
                {children}
              </a>
            ),
            list: ({ children }) => <ul className="list-disc list-inside mb-4 pl-4">{children}</ul>,
            oList: ({ children }) => <ol className="list-decimal list-inside mb-4 pl-4">{children}</ol>,
            listItem: ({ children }) => <li className="p-li mb-2">{children}</li>,
            oListItem: ({ children }) => <li className="p-li mb-2">{children}</li>,
            preformatted: ({ children }) => (
              <pre className="bg-gray-100 p-4 rounded-lg overflow-x-auto mb-4 font-mono text-sm">
                {children}
              </pre>
            ),
          }}
        />
      )}
    </section>
  );
};

export default Texte;
